package com.devi3east.bashbuddy.favorites.navigation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.navigation.NavGraphBuilder
import androidx.navigation.compose.composable
import com.devi3east.bashbuddy.favorites.ui.FavoriteEventsRoute
import com.devi3east.bashbuddy.features.app.data.AppState
import com.devi3east.bashbuddy.features.app.data.Screen
import com.devi3east.bashbuddy.features.common.ui.components.Loader

fun NavGraphBuilder.favoriteEventsNavGraph(
    appState: AppState,
    navigateToEventDetail: (eventId: String, slug: String) -> Unit
) {
    composable(Screen.FavoriteEventsScreen.route) {
        FavoriteEventsNavEntry(
            appState = appState,
            navigateToEventDetail = navigateToEventDetail
        )
    }

}

@Composable
private fun FavoriteEventsNavEntry(
    appState: AppState,
    navigateToEventDetail: (String, String) -> Unit
) {
    val uiState by appState.authViewModel.uiState.collectAsState()
    val profile = uiState.profile
    val  token = uiState.token

    if (token.isNullOrBlank()) {
        LaunchedEffect(Unit) {
            appState.navController.navigate(Screen.SignInScreen.route) {
                popUpTo(0)
            }
        }
        return
    }

    if (profile == null) {
        Loader()
        return
    }

    FavoriteEventsRoute(
        appState = appState,
        navigateToEventDetail = navigateToEventDetail
    )
}
